import styled from 'styled-components'
import colors from 'styles/colors'
import mediaQuery from 'styles/mediaQuery'

const H1 = styled.h1`
  font-size: 48px;
  line-height: 66px;
  text-align: center;
  margin-bottom: 50px;
  ${mediaQuery.mobile} {
    font-size: 32px;
    line-height: 44px;
    text-align: center;
  }
`
const H2 = styled.h2`
  font-size: 36px;
  line-height: 49px;
  margin-bottom: 16px;
  text-align: ${props => props.textAlign || 'left'};
  color: ${colors.black};
  ${mediaQuery.mobile} {
    font-size: 26px;
    line-height: 36px;
    text-align: center;
  }
`

const H3 = styled.h3`
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 16px;
  color: ${colors.gray};
`

const H4 = styled.h4`
  font-size: 20px;
  line-height: 24px;
  color: ${colors.textBlack};
`

const H5 = styled.h5`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: ${props => props.marginBottom || '7px'};
  font-weight: bold;
  color: ${colors.textBlack};
`
const H6 = styled.h6`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  font-weight: bold;
  color: ${colors.blueGray};
  ${mediaQuery.mobile} {
    text-align: center;
  }
`
const P = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${props => props.fontColor || colors.blueGray};
`

export { H1, H2, H3, H4, H5, H6, P }
